import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=5cd0bb60&"
import script from "./brands.vue?vue&type=script&lang=js&"
export * from "./brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd0bb60')) {
      api.createRecord('5cd0bb60', component.options)
    } else {
      api.reload('5cd0bb60', component.options)
    }
    module.hot.accept("./brands.vue?vue&type=template&id=5cd0bb60&", function () {
      api.rerender('5cd0bb60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/brands.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/brands.vue
// module id = 47
// module chunks = 0